/**
 * home/sections/CtaSection.tsx
 * Sección CTA: llamada a la acción para subir documento
 *
 * @version 2.0.0 — clases DS v2 alineadas con hero-v2.html
 */
import type { FC } from 'react';

export interface CtaSectionProps {
  /** Handler para seleccionar archivo (con comprobación de auth) */
  onFileSelect: () => void;
}

export const CtaSection: FC<CtaSectionProps> = ({ onFileSelect }) => (
  <section className="cta-section" id="cta">
    <div className="cta-inner">

      <div className="cta-eyebrow">
        <span className="cta-eyebrow-dot"></span>
        785 municipios · Andalucía
      </div>

      <h2 className="cta-title">
        ¿Preparado para normalizar tus<br />
        <span className="cta-accent">datos PTEL</span>?
      </h2>

      <p className="cta-desc">
        Sube tu documento y obtén coordenadas limpias,<br />
        validadas y listas para usar.
      </p>

      <div className="cta-actions">
        <button className="cta-btn-primary" onClick={onFileSelect} type="button">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="17 8 12 3 7 8" />
            <line x1="12" y1="3" x2="12" y2="15" />
          </svg>
          Subir documento
        </button>
        <a href="#features" className="cta-btn-secondary">Ver funcionalidades</a>
      </div>

      <div className="cta-metric">
        <div className="cta-metric-block">
          <span className="cta-metric-val">26,9&nbsp;%</span>
          <span className="cta-metric-lbl">geolocalización actual PTEL</span>
        </div>
        <div className="cta-metric-arrow">→</div>
        <div className="cta-metric-block">
          <span className="cta-metric-val good">95-100&nbsp;%</span>
          <span className="cta-metric-lbl">con PTEL Tool</span>
        </div>
      </div>

      <div className="cta-privacy">
        <span>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
          El documento permanece en tu navegador
        </span>
        <span>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <polyline points="20 6 9 17 4 12" />
          </svg>
          Sin coste
        </span>
        <span>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 8v4l3 3" />
          </svg>
          Resultado en minutos
        </span>
      </div>

    </div>
  </section>
);

export default CtaSection;
